<div id="linkDeviceOwnerCard" class="control-card-white">

  <div class="control-card-header">
    <ng-container i18n="@@linkdeviceowner_details">Collega gestore</ng-container>
  </div>

  <div class="control-card-content">

    <p class="linkdeviceowner-msg">
      <ng-container i18n="@@linkdeviceowner_msg">Seleziona il gestore al quale vuoi collegare il dispositivo
      </ng-container> {{device?.serial}}<br />
    </p>
    <div id="devicesList">
      <table mat-table matSort #linkdeviceownertable class="simple-table">

        <ng-container matColumnDef="displayName">
          <th mat-header-cell *matHeaderCellDef i18n="@@linkdeviceowner_name">Nome</th>
          <td mat-cell *matCellDef="let element"> {{ element.displayName }} </td>
        </ng-container>

        <ng-container matColumnDef="email">
          <th mat-header-cell *matHeaderCellDef i18n="@@linkdeviceowner_email">Email</th>
          <td mat-cell *matCellDef="let element"> {{ element.email }}
            <fa-icon icon="chevron-right" class="float-right padding-5"></fa-icon>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>

        <tr mat-row *matRowDef="let row; columns: displayedColumns;" (click)="onRowClicked(row)"
          [class.mat-cell-selected]="selectedRow == row.id" class="clickable">
        </tr>

      </table>
    </div>
    <app-loading-screen #linkdeviceownerloader></app-loading-screen>

  </div>

</div>
